import { ConsultMessages } from '../../__generated__/graphql';
import { capitalFirstLetter } from '../../Common/utils/string';
import { stringToColour } from '../../Common/utils/color';

type MessageThread = Pick<ConsultMessages, 'customer' | 'channel' | 'identityChannel'>;

export const titleForMessageThread = (message: MessageThread) => {
  if (message?.customer) {
    return `${message?.customer?.given} ${message?.customer?.surname}`;
  }

  let channelName = message?.channel ?? '';

  if (channelName === 'sinch_chat') {
    channelName = 'Web Chat'; // legacy channel — display name preserved for existing threads
  } else if (channelName === 'messenger') {
    channelName = 'Facebook';
  }

  return `${capitalFirstLetter(channelName)} ${message?.identityChannel}`;
};

export const colorForMessageThread = (message: MessageThread) => {
  return stringToColour(
    message?.customer
      ? `${message?.customer?.given} ${message?.customer?.surname}`
      : message?.identityChannel ?? '',
  );
};

export const initialForMessageThread = (message: MessageThread) => {
  if (message?.customer) {
    return `${message?.customer?.given?.substr(0, 1)}${message?.customer?.surname?.substr(
      0,
      1,
    )}`?.toUpperCase();
  }

  return '';
};
